import {Component, OnInit} from '@angular/core';
import {DocumentService} from '../../services/document.service';
import {DocHelper} from '../../services/document.helper';
import {Document, DocumentId} from '../../models/document.modal';
import {Router} from '@angular/router';

declare var $: any;

@Component({
    selector: 'app-doc-debit-order-authority',
    templateUrl: './doc-debit-order-authority.component.html',
    styleUrls: ['./doc-debit-order-authority.component.scss'],
    standalone: false
})
export class DocDebitOrderAuthorityComponent implements OnInit {

  docDetails: Document[] = [];
  arrDistinctList: string[] = [];
  printDoc = false;
  public DocumentId = DocumentId;

  constructor(
    private documentService: DocumentService,
    public router: Router
  ) {
    if (this.router.getCurrentNavigation()?.extras?.state) {
      this.printDoc = this.router.getCurrentNavigation()?.extras?.state?.print;
    }

  }

  ngOnInit(): void {
    this.documentService.getIP()
      .subscribe(res => {
        this.documentService.getDocument(DocumentId.DebitOrderAuthority, res?.ip)
          .subscribe((doc: Document[]) => {
            const dList = {};
            this.arrDistinctList = [];
            if (doc?.length) {
              this.docDetails = doc.sort((a, b) => a.index - b.index);

              this.docDetails.forEach(list => {
                if (!dList[list?.section_name] && list?.section_name.toLowerCase() !== 'header') {
                  dList[list?.section_name] = true;
                  this.arrDistinctList.push(list?.section_name);
                }
              });
              $([document.documentElement, document.body]).animate({
                scrollTop: $('.page').offset().top
              }, 0);
              setTimeout(() => {
                if (this.printDoc) {
                  window.print();
                }
              }, 1000);
            }
          });
      });
  }

  getDocumentSection(sectionName = ''): any[] {
    return DocHelper.getDocumentSection(this.docDetails, sectionName);
  }

}
